import { featuresData } from '@/mocks/home';

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          平台特色
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">为什么500万+用户选择51吃瓜</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-[1000px] mx-auto">
          {featuresData.map((feat, i) => (
            <div
              key={i}
              className="text-center p-6 bg-background-100 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center bg-primary-100 rounded-2xl">
                <i className={`${feat.icon} text-primary-600 text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2">
                {feat.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}